import { getJobStateMeta } from '@/modules/jobs/jobStates';
import type { JobApi } from '@/modules/jobs/types';
import { Badge } from '@/modules/ui/components/badge/Badge';
import { Paragraph } from '@/modules/ui/components/paragraph/Paragraph';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/modules/ui/components/tooltip/Tooltip';

interface JobStateTagProps {
  state: JobApi['state'];
}

const badgeClassNamesByState = {
  Published: 'border-sky-600 bg-sky-50 text-xs text-sky-700',
  Unpublished: 'border-slate-400 bg-slate-50 text-xs text-slate-700',
  OnHold: 'border-amber-500 bg-amber-50 text-xs text-amber-700',
  Hired: 'border-emerald-600 bg-emerald-50 text-xs text-emerald-700',
  Closed: 'border-rose-500 bg-rose-50 text-xs text-rose-700',
} satisfies Record<NonNullable<JobApi['state']>, string>;

export const JobStateTag = ({ state }: JobStateTagProps) => {
  const stateMeta = getJobStateMeta(state);

  if (!stateMeta) {
    return null;
  }

  const badge = (
    <Badge
      variant="outline"
      className={badgeClassNamesByState[stateMeta.value]}
    >
      {stateMeta.label}
    </Badge>
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>{badge}</div>
      </TooltipTrigger>
      <TooltipContent>
        <Paragraph variant="tooltip">{stateMeta.description}</Paragraph>
      </TooltipContent>
    </Tooltip>
  );
};
